/**
 * Database Service - Google Sheets Backend
 * All database operations now handled by Google Apps Script
 */

const APPS_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxSksZhJvdOvFpmM4UeJA8oezmoglWnKFR9d7iPKns2j4KxSWHvUVs8d3N1vkp4NjU/exec';

import type { Participant } from '@/types';

/**
 * Get participant data from Google Sheets
 */
export const getCachedParticipant = async (
  participantId: string
): Promise<Participant | null> => {
  try {
    const response = await fetch(`${APPS_SCRIPT_URL}?action=getParticipant&id=${participantId}`);
    const result = await response.json();
    
    if (result.success && result.participant) {
      return result.participant;
    }
    return null;
  } catch (error) {
    console.error('❌ Error getting participant:', error);
    return null;
  }
};

/**
 * Cache participant locally (localStorage)
 */
export const cacheParticipant = async (participant: Participant): Promise<void> => {
  try {
    localStorage.setItem('participant', JSON.stringify(participant));
  } catch (error) {
    console.error('❌ Error caching participant:', error);
  }
};

/**
 * Get participant from localStorage
 */
export const getLocalParticipant = (): Participant | null => {
  try {
    const data = localStorage.getItem('participant');
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error('❌ Error getting local participant:', error);
    return null;
  }
};

/**
 * Update email verification status
 */
export const updateCachedEmailVerification = async (
  participantId: string,
  verified: boolean
): Promise<void> => {
  try {
    const participant = getLocalParticipant();
    if (participant && participant.id === participantId) {
      participant.emailVerified = verified;
      localStorage.setItem('participant', JSON.stringify(participant));
    }
  } catch (error) {
    console.error('❌ Error updating verification status:', error);
  }
};